module.exports = __webpack_public_path__ + "img/messenger-bg.9806e204.svg";